import { defineStore } from 'pinia';
import { getRelatedBooths, getStockUpInfo } from '@/api/seller/order';

type DeliverStatus = 0 | 2 | 5 | 7;

interface Option {
  text: string
  value: DeliverStatus
  color: string
}

interface StandbyStatisticiansState {
  boothsList: API.BoothsItem[]
  activeKey: string
  tbData: API.ProductItemAtStockUpInfo[]
  number: Record<string, number>
  option: Option[]
}

export const useStandbyStatisticians = defineStore({
  id: 'seller-standby-statisticians',
  state: (): StandbyStatisticiansState => ({
    boothsList: [],
    activeKey: '',
    tbData: [],
    number: {},
    option: [
      { text: '待备货', value: 0, color: '#faad14' },
      { text: '备货中', value: 2, color: '#52c41a' },
      { text: '缺货中', value: 5, color: '#ff4d4f' },
      { text: '已拿货', value: 7, color: '#8c8c8c' },
    ],
  }),
  getters: {
    statisticians(): any[] {
      return this.option.map((op: Option) => ({
        text: op.text,
        value: op.value,
        color: op.color,
        number: this.number[op.value],
      }));
    },
    getColor(): (text: string) => string {
      return (text: string) => {
        const op = this.option.find(item => item.text === text);
        return op ? op.color : '';
      };
    },
  },
  actions: {
    async getBoothsList() {
      const res = await getRelatedBooths();
      if (res && (res as any).length > 0) {
        this.boothsList = res as any;
        this.activeKey = `${this.boothsList[0].seller_id}_${this.boothsList[0].pool_seller_sign}`;
      }
    },
    async getInfo(key?: string, state?: DeliverStatus) {
      const [poolSellerId, poolSellerSign] = this.activeKey === '' ? [] : this.activeKey.split('_');
      return getStockUpInfo({
        pool_seller_id: poolSellerId,
        pool_seller_sign: poolSellerSign,
        key,
        deliver_status: state,
      }).then((data: any) => {
        const activeBooth = this.boothsList.find(
          item => item.seller_id === Number(this.activeKey.split('_')[0]),
        );
        const shopName = activeBooth?.shop_name || '';
        this.tbData = (data.list || []).map((item: API.ProductItemAtStockUpInfo) => ({
          ...item,
          sku_code: shopName ? item.sku_code.replace(`${shopName}#`, '') : item.sku_code,
        }));
        if (key === undefined && state === undefined) {
          this.option.forEach((op) => {
            if (op.value !== undefined) {
              this.number[op.value] = (data.list || [])
                .filter((item: any) => item.deliver_status_arr.some((s: any) => s.deliver_status === op.text))
                .reduce((total: number, item: any) => {
                  const status = item.deliver_status_arr.find((s: any) => s.deliver_status === op.text);
                  return total + (status?.goods_num || 0);
                }, 0);
            }
          });
        }
        else if (key === undefined && state !== undefined) {
          const opt = this.option.find(item => item.value === state);
          if (opt) {
            this.number[state] = (data.list || []).reduce((total: number, item: any) => {
              const status = item.deliver_status_arr.find((s: any) => s.deliver_status === opt.text);
              return total + (status?.goods_num || 0);
            }, 0);
          }
        }
      });
    },
    setActiveKey(key: string) {
      this.activeKey = key;
    },
  },
});
